import React from 'react'

import './styles.css'

interface ErrorTextProps {
  children: React.ReactNode
}

/**
 * Inline form-field error message.
 *
 * Render directly under an input inside a `<Form.Field error>` to display
 * a validation message in the standard Simplesat negative-text style.
 */
export default function ErrorText({ children }: ErrorTextProps) {
  if (!children) {
    return null
  }
  return <p className="ss-error-form-input">{children}</p>
}



// WEBPACK FOOTER //
// ./src/shared/components/forms/ErrorText/index.tsx